// import { ENVIRONMENT } from './constants'
const getCallbackUrl = () => {
  let currentUrl = window.location.href
  const splittedURL = currentUrl.split('/')
  const protocol = splittedURL[0]
  const siteUrl = splittedURL[2]
  return protocol + '//' + siteUrl + '/auth0-callback'
}
// var callbackUrl = ''
// if (ENVIRONMENT === 'production') {
//   callbackUrl = 'https://connect.alem.health/auth0-callback'
// } else if (ENVIRONMENT === 'development') {
//   callbackUrl = 'https://dev-telerad-portal-app.azurewebsites.net/auth0-callback'
// } else {
//   callbackUrl = 'http://localhost:3000/auth0-callback'
// }

// const AUTH0_ROOT_URL = 'https://alemhealthlog.eu.auth0.com'
// export const AUTH0_TOKEN_URL = AUTH0_ROOT_URL + '/oauth/token'

// const AUTH0_API_URL = AUTH0_ROOT_URL + '/api/v2'
// export const AUTH0_GET_USERS_BY_MAIL = AUTH0_API_URL + '/users-by-email'
// export const AUTH0_CREATE_NEW_USER = AUTH0_API_URL + '/users'
// export const AUTH0_SIGNUP_URL = AUTH0_ROOT_URL + '/dbconnections/signup'

export const META_DATA_PREFIX = 'https://connect.alem.health/'

export const AUTH_CONFIG = {
  domain: 'login.alem.health',
  clientID: process.env.REACT_APP_AUTH0_CLIENT_ID, // AlemHealth Connect
  connection: 'TeleRadUsers',
  audience: 'https://alemhealthapi.azure-api.net/',
  redirectUri: getCallbackUrl(),
  responseType: 'token id_token',
  scope: 'openid email profile'
}

export const CONNECT_SUBSCRIPTION_KEY = '2792cff2e98b42f785e17f92448df044'

export const FACILITY_SUBSCRIPTION_KEY = '50bed87351684bc88eb8fcfd4fdadeda'

export const Dev_CONNECT_SUBSCRIPTION_KEY = 'aa2a7b94cde045f5b03e6a697b86ab4c'